export default "__VITE_ASSET__B5LmJYd5__"